import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import WareHouses from "./views/WareHouses.vue";
import Vineyards from "./views/Vineyards.vue";
import Additive from "./views/Additive.vue";
import PhenoPhase from "./views/PhenoPhase.vue";
import BreedingType from "./views/BreedingType.vue";
import PruningType from "./views/PruningType.vue";
import Parameter from "./views/Parameter.vue";
import SetParameter from "./views/SetParameter.vue";
import SetComment from "./views/SetComment.vue";
import SetTankPhase from "./views/SetTankPhase.vue";
import SetTankWine from "./views/SetTankWine.vue";
import SetParameterTank from "./views/SetParameterTank.vue";
import SugarTemperatureTank from "./views/SugarTemperatureTank.vue";
import AdditiveGroup from "./views/AdditiveGroup.vue";
import WareHouseType from "./views/WareHouseType.vue";
import WareHouseTypePom from "./views/WareHouseTypePom.vue";
import WareHouse from "./views/WareHouse.vue";
import Currency from "./views/Currency.vue";
import Winery from "./views/Winery.vue";
import GrapeVariety from "./views/GrapeVariety.vue";
import Phase from "./views/Phase.vue";
import Room from "./views/Room.vue";
import Employee from "./views/Employee.vue";
import ExternalWorkForce from "./views/ExternalWorkForce.vue";
import Mehanization from "./views/Mehanization.vue";
import VineyardOperation from "./views/VineyardOperation.vue";
import RoomPom from "./views/RoomPom.vue";
import TankType from "./views/TankType.vue";
import Tank from "./views/Tank.vue";
import TankPom from "./views/TankPom.vue";
import UnitOfMeasure from "./views/UnitOfMeasure.vue";
import VineYardBlock from "./views/VineYardBlock.vue";
import VineYardTable from "./views/VineYardTable.vue";
import UnitOfMeasureGroup from "./views/UnitOfMeasureGroup.vue";
import VineYard from "./views/VineYard.vue";
import WineType from "./views/WineType.vue";
import Adding from "./views/Adding.vue";
import WareHouseInputBotlle from "./views/WareHouseInputBotlle.vue";
import WareHouseLaunch from "./views/WareHouseLaunch.vue";
import WareHouseInput from "./views/WareHouseInput.vue";
import WareHouseSelling from "./views/WareHouseSelling.vue";
import WareHouseSellingWine from "./views/WareHouseSellingWine.vue";
import WareHouseOutputOff from "./views/WareHouseOutputOff.vue";
import WareHouseOutputOffWine from "./views/WareHouseOutputOffWine.vue";
import WareHouseTurnBack from "./views/WareHouseTurnBack.vue";
import WareHouseTurnBackWine from "./views/WareHouseTurnBackWine.vue";
import Measurement from "./views/Measurement.vue";
import FunctionPouring from "./views/FunctionPouring.vue";
import GrapeInput from "./views/GrapeInput.vue";
import SingleTank from "./views/SingleTank.vue";
import SingleVineyard from "./views/SingleVineyard.vue";
import WareHouseList from "./views/WareHouseList.vue";
import EmptyTank from "./views/EmptyTank.vue";
import TankRoom from "./views/TankRoom.vue";
import WareHouseTypeItems from "./views/WareHouseTypeItems.vue";
// import Rooms from "./views/Rooms.vue";
import Filling from "./views/Filling.vue";
import Filtering from "./views/Filtering.vue";
import Decanting from "./views/Decanting.vue";
import Pressing from "./views/Pressing.vue";
import Coupage from "./views/Coupage.vue";
import Timeline from "./views/Timeline.vue";
import SingleVine from "./views/SingleVine.vue";
import WineTypes from "./views/WineTypes.vue";
import VineType from "./views/VineType.vue";
import VineYear from "./views/VineYear.vue";
import WineLabel from "./views/WineLabel.vue";
import WineLabelModal from "./views/WineLabelModal.vue";
import Wine from "./views/Wine.vue";
import WineModal from "./views/WineModal.vue";
import VineyardGrape from "./views/VineyardGrape.vue";
import Company from "./views/Company.vue";

import WareHouseInfo from "./views/WareHouseInfo.vue";
import VineYardInfo from "./views/VineYardInfo.vue";
import CatalogInfo from "./views/CatalogInfo.vue";
import CatalogInfoOther from "./views/CatalogInfoOther.vue";

import Grafik from "./views/Grafik.vue";
import GrafikItem from "./views/GrafikItem.vue";

import Login from "./views/Login.vue";

import ModalUmodalu from "./views/ModalUmodalu.vue";

Vue.use(Router);

export default new Router({
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior (to, from, savedPosition) {
		// alert(888);
		return { x: 0, y: 0 }
	  },
	routes: [
		{
			path: "/home",
			name: "home",
			component: Home,
			meta: {
			  breadcrumb:[
				{ name: "Pregled prostorija"}
			  ]
			}

		},
		{
			path: "/ware_houses",
			name: "ware_houses",
			component: WareHouses,
			meta: {
			  breadcrumb:[
				{ name: "Pregled magacina"}
			  ]
			}

		},
		{
			path: "/vineyards",
			name: "vineyards",
			component: Vineyards,
			meta: {
			  breadcrumb:[
				{ name: "Pregled vinograda"}
			  ]
			}

		},
		{
			path: "/login",
			name: "login",
			component: Login		

		},{
			path: "/additive",
			name: "additive",
			component: Additive,
			meta: {
			  breadcrumb:[
				{ name: "Aditivi"}
			  ]
			}
		},{
			path: "/phenophase",
			name: "phenophase",
			component: PhenoPhase,
			meta: {
			  breadcrumb:[
				{ name: "PhenoPhase"}
			  ]
			}
		},{
			path: "/breedingtype",
			name: "breedingtype",
			component: BreedingType,
			meta: {
			  breadcrumb:[
				{ name: "BreedingType"}
			  ]
			}
		},{
			path: "/pruningtype",
			name: "pruningtype",
			component: PruningType,
			meta: {
			  breadcrumb:[
				{ name: "PruningType"}
			  ]
			}
		},
		{
			path: "/parameter",
			name: "parameter",
			component: Parameter,
			meta: {
			  breadcrumb:[
				{ name: "Parametri"}
			  ]
			}
		},
		{
			path: "/setparameter",
			name: "setparameter",
			component: SetParameter,
			meta: {
			  breadcrumb:[
				{ name: "Parametri podesavanja"}
			  ]
			}
		},
		{
			path: "/setcomment",
			name: "setcomment",
			component: SetComment,
			meta: {
			  breadcrumb:[
				{ name: "Unos komentara"}
			  ]
			}
		},
		{
			path: "/setTankPhase",
			name: "setTankPhase",
			component: SetTankPhase,
			meta: {
			  breadcrumb:[
				{ name: "Unos komentara"}
			  ]
			}
		},
		{
			path: "/setTankWine",
			name: "setTankWine",
			component: SetTankWine,
			meta: {
			  breadcrumb:[
				{ name: "Unos komentara"}
			  ]
			}
		},
		{
			path: "/settankparameter",
			name: "settankparameter",
			component: SetParameterTank,
			meta: {
			  breadcrumb:[
				{ name: "Parametri podesavanja"}
			  ]
			}
		},
		{
			path: "/sugartemperaturetank",
			name: "sugartemperaturetank",
			component: SugarTemperatureTank,
			meta: {
			  breadcrumb:[
				{ name: "Parametri podesavanja"}
			  ]
			}
		},
		{
			path: "/additive_group",
			name: "additive_group",
			component: AdditiveGroup,
			meta: {
			  breadcrumb:[
				{ name: "Grupe aditiva"}
			  ]
			}
		},
		{
			path: "/warehause_type",
			name: "warehause_type",
			component: WareHouseType,
			meta: {
			  breadcrumb:[
				{ name: "Grupe aditiva"}
			  ]
			}
		},
		{
			path: "/warehause_type_pom",
			name: "warehause_type_pom",
			component: WareHouseTypePom,
			meta: {
			  breadcrumb:[
				{ name: "Grupe aditiva"}
			  ]
			}
		},
		{
			path: "/ware_house",
			name: "ware_house",
			component: WareHouse,
			meta: {
			  breadcrumb:[
				{ name: "Grupe aditiva"}
			  ]
			}
		},
		{
			path: "/currency",
			name: "currency",
			component: Currency,
			meta: {
			  breadcrumb:[
				{ name: "Valute"}
			  ]
			}
		},
		{
			path: "/winery",
			name: "winery",
			component: Winery,
			meta: {
			  breadcrumb:[
				{ name: "Valute"}
			  ]
			}
		},
		{
			path: "/grape_variety",
			name: "grape_variety",
			component: GrapeVariety,
			meta: {
			  breadcrumb:[
				{ name: "Vrste grodja"}
			  ]
			}
		},
		{
			path: "/phase",
			name: "phase",
			component: Phase,
			meta: {
			  breadcrumb:[
				{ name: "Faze"}
			  ]
			}
		},
		{
			path: "/employee",
			name: "employee",
			component: Employee,
			meta: {
			  breadcrumb:[
				{ name: "Faze"}
			  ]
			}
		},
		{
			path: "/externalWorkForce",
			name: "externalWorkForce",
			component: ExternalWorkForce,
			meta: {
			  breadcrumb:[
				{ name: "Faze"}
			  ]
			}
		},
		{
			path: "/mehanization",
			name: "mehanization",
			component: Mehanization,
			meta: {
			  breadcrumb:[
				{ name: "Faze"}
			  ]
			}
		},
		{
			path: "/vineyard_operation",
			name: "vineyard_operation",
			component: VineyardOperation,
			meta: {
			  breadcrumb:[
				{ name: "Faze"}
			  ]
			}
		},
		{
			path: "/tank_sif",
			name: "tank_sif",
			component: TankPom,
			meta: {
			  breadcrumb:[
				
			  ]
			}
		},
		{
			path: "/room_sif",
			name: "room_sif",
			component: RoomPom,
			meta: {
			  breadcrumb:[
				
			  ]
			}
		},
		{
			path: "/room",
			name: "room",
			component: Room,
			meta: {
			  breadcrumb:[
				{ name: "Pregled prostorija", link:"/home"},
				{ name: "Prostorije"}
			  ]
			}
		},
		{
			path: "/tank",
			name: "tank",
			component: Tank,
			meta: {
			  breadcrumb:[
				{ name: "Tankovi"}
			  ]
			}
		},
		{
			path: "/tank_type",
			name: "tank_type",
			component: TankType,
			meta: {
			  breadcrumb:[
				{ name: "Tipovi tankova"}
			  ]
			}
		},
		{
			path: "/unit_of_measure",
			name: "unit_of_measure",
			component: UnitOfMeasure,
			meta: {
			  breadcrumb:[
				{ name: "Jedinice mere"}
			  ]
			}
		},
		{
			path: "/vine_yard_block",
			name: "vine_yard_block",
			component: VineYardBlock,
			meta: {
			  breadcrumb:[
				{ name: "Jedinice mere"}
			  ]
			}
		},
		{
			path: "/vine_yard_table",
			name: "vine_yard_table",
			component: VineYardTable,
			meta: {
			  breadcrumb:[
				{ name: "Jedinice mere"}
			  ]
			}
		},
		// {
		// 	path: "/vine_yard_row",
		// 	name: "vine_yard_row",
		// 	component: VineYardRow,
		// 	meta: {
		// 	  breadcrumb:[
		// 		{ name: "Jedinice mere"}
		// 	  ]
		// 	}
		// },
		{
			path: "/unit_of_measure_group",
			name: "unit_of_measure_group",
			component: UnitOfMeasureGroup,
			meta: {
			  breadcrumb:[
				{ name: "Grupe jedinica mere"}
			  ]
			}
		},
		{
			path: "/vine_yard",
			name: "vine_yard",
			component: VineYard,
			meta: {
			  breadcrumb:[
				{ name: "Pregled vinograda"}
			  ]
			}
		},
		{
			path: "/wine_types_all",
			name: "wine_types_all",
			component: WineType,
			meta: {
			  breadcrumb:[
				{ name: "Tipovi vina"}
			  ]
			}
		},
		{
			path: "/adding",
			name: "adding",
			component: Adding,
			meta: {
			  breadcrumb:[
				{ name: "Dodavanja"}
			  ]
			}
		},
		{
			path: "/ware_house_botlle",
			name: "ware_house_botlle",
			component: WareHouseInputBotlle//,
			// meta: {
			//   breadcrumb:[
			// 	{ name: "Dodavanja"}
			//   ]
			// }
		},
		{
			path: "/ware_house_launch",
			name: "ware_house_launch",
			component: WareHouseLaunch//,
			// meta: {
			//   breadcrumb:[
			// 	{ name: "Dodavanja"}
			//   ]
			// }
		},
		{
			path: "/ware_house_selling",
			name: "ware_house_selling",
			component: WareHouseSelling//,
			// meta: {
			//   breadcrumb:[
			// 	{ name: "Dodavanja"}
			//   ]
			// }
		},
		{
			path: "/ware_house_selling_wine",
			name: "ware_house_selling_wine",
			component: WareHouseSellingWine//,
			// meta: {
			//   breadcrumb:[
			// 	{ name: "Dodavanja"}
			//   ]
			// }
		},
		{
			path: "/ware_house_outputoff",
			name: "ware_house_outputoff",
			component: WareHouseOutputOff//,
			// meta: {
			//   breadcrumb:[
			// 	{ name: "Dodavanja"}
			//   ]
			// }
		},
		{
			path: "/ware_house_outputoff_wine",
			name: "ware_house_outputoff_wine",
			component: WareHouseOutputOffWine//,
			// meta: {
			//   breadcrumb:[
			// 	{ name: "Dodavanja"}
			//   ]
			// }
		},
		{
			path: "/ware_house_turnback",
			name: "ware_house_turnback",
			component: WareHouseTurnBack//,
			// meta: {
			//   breadcrumb:[
			// 	{ name: "Dodavanja"}
			//   ]
			// }
		},
		{
			path: "/ware_house_turnback_wine",
			name: "ware_house_turnback_wine",
			component: WareHouseTurnBackWine//,
			// meta: {
			//   breadcrumb:[
			// 	{ name: "Dodavanja"}
			//   ]
			// }
		},
		{
			path: "/ware_house_input",
			name: "ware_house_input",
			component: WareHouseInput//,
			// meta: {
			//   breadcrumb:[
			// 	{ name: "Dodavanja"}
			//   ]
			// }
		},
		{
			path: "/measurement",
			name: "measurement",
			component: Measurement,
			meta: {
			  breadcrumb:[
				{ name: "Merenja"}
			  ]
			}
		},
		{
			path: "/functionPouring",
			name: "functionPouring",
			component: FunctionPouring,
			meta: {
			  breadcrumb:[
				{ name: "FunctionPouring"}
			  ]
			}
		},
		{
			path: "/grape_input",
			name: "grape_input",
			component: GrapeInput,
			meta: {
			  breadcrumb:[
				{ name: "Ulaz grozdja"}
			  ]
			}
		},
		{
			path: "/filling",
			name: "filling",
			component: Filling,
			meta: {
			  breadcrumb:[
				{ name: "Punjenje"}
			  ]
			}
		},
		{
			path: "/filtering",
			name: "filtering",
			component: Filtering,
			meta: {
			  breadcrumb:[
				{ name: "Filtriranje"}
			  ]
			}
		},
		{
			path: "/decanting",
			name: "decanting",
			component: Decanting,
			meta: {
			  breadcrumb:[
				{ name: "Funkcije"}
			  ]
			}
		},
		{
			path: "/pressing",
			name: "pressing",
			component: Pressing,
			meta: {
			  breadcrumb:[
				{ name: "Funkcije"}
			  ]
			}
		},
		{
			path: "/coupage",
			name: "coupage",
			component: Coupage,
			meta: {
			  breadcrumb:[
				{ name: "Funkcije"}
			  ]
			}
		}, {
			path: "/single_tank/:id",
			name: "single_tank",
			component: SingleTank,
			meta: {
			  breadcrumb:[
					{ name: "Pregled prostorija", link:"/home"},
					{ name: "", link:"/tank_room"},
					{ name: "Tank"}
			  ]
			}
		}, {
			path: "/single_vineyard/:id",
			name: "single_vineyard",
			component: SingleVineyard,
			meta: {
			  breadcrumb:[
					{ name: "Pregled vinograda", link:"/vineyards"},
					{ name: "Tank"}
			  ]
			}
		}, {
			path: "/ware_house_list/:id",
			name: "ware_house_list",
			component: WareHouseList,
			meta: {
			  breadcrumb:[
					{ name: "Pregled magacina", link:"/ware_houses"},
					{ name: "", link:"/warehouse_type"},
					{ name: ""}
			  ]
			}
		},
		{
			path: "/empty_tank/:id",
			name: "empty_tank",
			component: EmptyTank,
			meta: {
			  breadcrumb:[
				{ name: "Pregled prostorija", link:"/home"},
				{ name: "", link:"/tank_room"},
				{ name: "Tank"}
			  ]
			}
		}, {
			path: "/tank_room/:id",
			name: "tank_room",
			component: TankRoom,
			meta: {
			  breadcrumb:[
				{ name: "Pregled prostorija", link:"/home"},
				{ name: ""}
			  ]
			}
		}, {
			path: "/warehouse_type/:id/:warehouse_type_name",
			name: "warehouse_type",
			component: WareHouseTypeItems,
			meta: {
			  breadcrumb:[
				{ name: "Pregled magacina", link:"/ware_houses"},
				{ name: ""}
			  ]
			}
		}, 
		// {
		// 	path: "/rooms",
		// 	name: "rooms",
		// 	component: Rooms,
		// 	meta: {
		// 	  breadcrumb:[
		// 		{ name: "Prostorije"}
		// 	  ]
		// 	}
		// },
		 {
			path: "/timeline",
			name: "timeline",
			component: Timeline,
			meta: {
			  breadcrumb:[
				{ name: "Timeline"}
			  ]
			}
		}, {
			path: "/wine_types",
			name: "wine_types",
			component: WineTypes,
			meta: {
			  breadcrumb:[
				{ name: "Pregled vina"}
			  ]
			}
		},{
			path: "/wine_type/:id",
			name: "wine_type",
			component: VineType,
			meta: {
			  breadcrumb:[
				{ name: "Pregled vina", link:"/wine_types"},
				{ name: ""}
			  ]
			}
		},{
			path: "/wine_year/:id",
			name: "wine_year",
			component: VineYear,
			meta: {
			  breadcrumb:[
				{ name: "Pregled vina", link:"/wine_types"},
				{ name: "", link:""},
				{ name: ""}
			  ]
			}
		}, {
			path: "/single_wine/:id",
			name: "single_wine",
			component: SingleVine,
			meta: {
			  breadcrumb:[
					{ name: "Pregled vina", link:"/wine_types"},
					{ name: "", link:""},
					{ name: "", link:""},
					{ name: ""}
			  ]
			}
		},
		{
			path: "/wine_label",
			name: "wine_label",
			component: WineLabel,
			meta: {
			  breadcrumb:[
				{ name: "Etiketa"}
			  ]
			}
		},
		{
			path: "/wine_label_modal",
			name: "wine_label_modal",
			component: WineLabelModal,
			meta: {
			  breadcrumb:[
				{ name: "Etiketa"}
			  ]
			}
		},
		{
			path: "/vineyard_grape",
			name: "vineyard_grape",
			component: VineyardGrape,
			meta: {
			  breadcrumb:[
				{ name: "Vina"}
			  ]
			}
		},
		{
			path: "/company",
			name: "company",
			component: Company,
			meta: {
			  breadcrumb:[
				{ name: "Kompanije"}
			  ]
			}
		},
		{
			path: "/vineyard_info",
			name: "vineyard_info",
			component: VineYardInfo,
			meta: {
			  breadcrumb:[
				{ name: "Vina"}
			  ]
			}
		},
		{
			path: "/catalog_info",
			name: "catalog_info",
			component: CatalogInfo,
			meta: {
			  breadcrumb:[
				{ name: "Vina"}
			  ]
			}
		},
		{
			path: "/catalog_info_other",
			name: "catalog_info_other",
			component: CatalogInfoOther,
			meta: {
			  breadcrumb:[
				{ name: "Vina"}
			  ]
			}
		},
		{
			path: "/warehouse_info",
			name: "warehouse_info",
			component: WareHouseInfo,
			meta: {
			  breadcrumb:[
				{ name: "Vina"}
			  ]
			}
		},
		{
			path: "/grafik",
			name: "grafik",
			component: Grafik,
			meta: {
			  breadcrumb:[
				{ name: "Grafik"}
			  ]
			}
		},
		{
			path: "/grafikitem",
			name: "grafikitem",
			component: GrafikItem,
			meta: {
			  breadcrumb:[
				{ name: "Grafik"}
			  ]
			}
		},
		{
			path: "/wine",
			name: "wine",
			component: Wine,
			meta: {
			  breadcrumb:[
				{ name: "Vina"}
			  ]
			}
		},
		{
			path: "/wine_modal",
			name: "wine_modal",
			component: WineModal,
			meta: {
			  breadcrumb:[
				{ name: "Vina"}
			  ]
			}
		},
		{
			path: "/modal_primer",
			name: "modal_primer",
			component: ModalUmodalu
		}
		/*   {
			path: "/about",
			name: About,
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.

		} */
	]
});
